import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ActivateInactivatePersonUseCaseInterface } from 'domain/usecases';

export class RemoteActivateInactivatePerson
  implements ActivateInactivatePersonUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: ActivateInactivatePersonUseCaseInterface.Params,
  ): Promise<ActivateInactivatePersonUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.activeStatus}/${params.id}`,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
